import { delay, getTransitionDuration } from '../../utils/utils'
import BaseComponent from '../base-component/base-component'

class Tab extends BaseComponent {
  transitionDuration: number
  styles: CSSStyleDeclaration

  constructor() {
    super()

    this.styles = getComputedStyle(this)
  }

  show(): Promise<void> {
    this.setVisible(true)

    return delay(getTransitionDuration(this.styles))
  }

  hide(): Promise<void> {
    this.setVisible(false)

    return delay(getTransitionDuration(this.styles))
  }

  setVisible(isVisible: boolean): void {
    this.setAttribute('aria-hidden', isVisible ? 'false' : 'true')
  }

  get isVisible(): boolean {
    return this.getAttribute('aria-hidden') === 'false'
  }
}

export default Tab
